var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4",attrs:{"id":"marketplace"}},[_c('div',{staticClass:"clearfix gibson px2 pt2 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px0"},[_c('div',[_c('marketplace')],1)]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix ml4"},[_c('div',[_c('marketplace')],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58aaecf9","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/portal/Start.vue
// module id = 816
// module chunks = 4